"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importBuiltins = exports.ensureGlobalEnvironmentExist = exports.createEmptyContext = void 0;
const builtIns_1 = require("./builtIns");
const constants_1 = require("./constants");
const macros_prelude_1 = require("./stdlib/macros.prelude");
const misc = require("./stdlib/misc");
const procedures_prelude_1 = require("./stdlib/procedures.prelude");
const stringify_1 = require("./utils/stringify");
const createEmptyRuntime = () => ({
    break: false,
    debuggerOn: true,
    isRunning: false,
    environments: [],
    value: undefined,
    nodes: [],
    inTailContext: [],
    nextUniqueSymbolNumber: 0
});
const createGlobalEnvironment = () => ({
    tail: null,
    name: 'global',
    head: {}
});
const createEmptyContext = (variant, externalSymbols, externalContext, moduleParams) => {
    return {
        externalSymbols,
        errors: [],
        externalContext,
        moduleParams,
        runtime: createEmptyRuntime(),
        numberOfOuterEnvironments: 1,
        prelude: null,
        executionMethod: 'auto',
        variant
    };
};
exports.createEmptyContext = createEmptyContext;
const ensureGlobalEnvironmentExist = (context) => {
    if (!context.runtime) {
        context.runtime = createEmptyRuntime();
    }
    if (!context.runtime.environments) {
        context.runtime.environments = [];
    }
    if (context.runtime.environments.length === 0) {
        context.runtime.environments.push(createGlobalEnvironment());
    }
};
exports.ensureGlobalEnvironmentExist = ensureGlobalEnvironmentExist;
const defineSymbol = (context, name, value) => {
    const globalEnvironment = context.runtime.environments[0];
    globalEnvironment.head[name] = value;
};
const importExternalBuiltins = (context, externalBuiltIns) => {
    const externalDisplay = (v) => externalBuiltIns.rawDisplay(stringify_1.stringify(v), undefined, // Workaround for rawDisplay hack on frontend
    context.externalContext);
    const displayProcedure = {
        type: 'procedure',
        name: 'display',
        callSignature: {
            style: 'fixed-args',
            numParams: 1
        },
        variant: 'BuiltInProcedure',
        body: (args) => {
            externalDisplay(args[0]);
            return args[0];
        }
    };
    defineSymbol(context, 'display', displayProcedure);
};
/**
 * Imports builtins from standard and external libraries.
 */
const defaultBuiltIns = {
    rawDisplay: misc.rawDisplay
};
const importPrelude = (context) => {
    context.prelude = procedures_prelude_1.stdlibProcedures;
    if (context.variant === 'macro') {
        context.prelude += macros_prelude_1.stdlibMacros;
    }
};
const importBuiltins = (context, externalBuiltIns) => {
    exports.ensureGlobalEnvironmentExist(context);
    importExternalBuiltins(context, externalBuiltIns);
    builtIns_1.importNativeBuiltins(context);
};
exports.importBuiltins = importBuiltins;
const createContext = (variant = constants_1.defaultVariant, externalSymbols = [], externalContext, externalBuiltIns = defaultBuiltIns, moduleParams) => {
    const context = exports.createEmptyContext(variant, externalSymbols, externalContext, moduleParams);
    importPrelude(context);
    exports.importBuiltins(context, externalBuiltIns);
    return context;
};
exports.default = createContext;
//# sourceMappingURL=createContext.js.map